/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mcp_Servers_Field_Url_PlaceholderInputs */



/**
* | output |
* | --- |
* | "https://mcp.example.com/api" |
*
* @param {Mcp_Servers_Field_Url_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const mcp_servers_field_url_placeholder = /** @type {((inputs?: Mcp_Servers_Field_Url_PlaceholderInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mcp_Servers_Field_Url_PlaceholderInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("https://mcp.example.com/api")
	return /** @type {LocalizedString} */ ("https://mcp.example.com/api")
});